import { Component, Input, OnInit, Inject, LOCALE_ID, ViewChild } from '@angular/core';
import { formatNumber } from '@angular/common';
import { InputComponent, MakeProvider } from '../input-component';
import { IonInput } from '@ionic/angular';
import { getCurrencySymbol } from '@angular/common';
import { Utilities } from 'src/app/core/helper/util';

@Component({
  selector: 'app-number-input',
  templateUrl: './number-input.component.html',
  styleUrls: ['./number-input.component.scss'],
  providers: [MakeProvider(NumberInputComponent)]
})
export class NumberInputComponent extends InputComponent implements OnInit {

  @Input() min: number;
  @Input() max: number;
  @Input() currency: string;
  @Input() allowDecimals = false;
  @Input() decimalPlaces = 2;
  @Input() allowNull: boolean = false;
  @Input() allowZero: boolean = false;
  @Input() maxWidth = 'none';

  @ViewChild('numberInput', { static: false }) numberInput: IonInput;

  currencySym: string;

  constructor(
    @Inject(LOCALE_ID) public locale: string
  ) { super(); }

  ngOnInit() {
    this.currencySym = this.currency != null ? getCurrencySymbol(this.currency.toUpperCase(), 'narrow') : undefined;
    setTimeout(() => {
      const format = formatNumber(this.value, this.locale);
      const v = +format.replace(/[\,]/g, '');
      if ((this.allowZero && v >= 0) || (!this.allowZero && v > 0)) { // was not rendering when value was 0 even though it was allowed
        this.numberInput.value = `${this.currency ? this.currencySym : ''}${format}`;
      } else {
        this.numberInput.value = '';
      }
    });
  }

  onBlur(event) {
    this.checkValidity();
    this.maskNumber(event);
    this.blurred.emit();
    if (this.isValid) {
      this.blurredAndValid.emit();
    }
  }

  gotFocus() {
    // Access the native input element
    const nativeInput = this.numberInput.getInputElement();

    // Use the native 'select' method to select the text
    nativeInput.then(input => {
      input.select();
    });
  }

  onInputChange(event) {
    if (this.allowDecimals === false) {
      this.maskNumber(event);
    }
  }

  maskNumber(event) {
    if (Utilities.stringEmpty(event.target?.value?.toString())) {
      this.value = undefined;
      event.target.value = '';
    } else {
      const numbers = +(this.getNumbers(event.target.value).join(''));
      if (numbers >= 0) {
        this.value = numbers;
        const formatStr = (this.allowDecimals) ? `1.${this.decimalPlaces}-${this.decimalPlaces}` : '1.0-0';
        const format = formatNumber(numbers, this.locale, formatStr);
        const newVal = `${this.currency ? this.currencySym : ''}${format}`;
        if (newVal !== event.target.value) {
          event.target.value = newVal;
        }
      } else {
        this.value = null;
        event.target.value = '';
      }
    }
  }

  override checkValidity() {
    if (this.required && (this.value == null || (!this.allowZero && this.value === 0))) {
      this.focusInvalidElement();
    } else if (this.value < this.min) {
      this.focusInvalidElement(`Value should be greater than ${this.min - 1}`);
    } else if (this.value > this.max) {
      this.focusInvalidElement(`Value should be less than ${this.max + 1}`);
    } else {
      this.isValid = true;
      this.checkingValidity.emit(this);
    }
  }

  override updateValue() {
    if (this.numberInput != null) {
      this.numberInput.value = this.value;
    }
  }

  protected getNumbers(value: string) {
    if (value) {
      const val = value.toString();
      const arr: string[] = [];
      for (let i = 0; i < val.toString().length; i++) {
        //checks if input is a digit
        if (this.allowDecimals === false && val[i]?.match('\\d')) {
          arr.push(val[i]!);
        } else if (this.allowDecimals === true && (val[i]?.match('\\d') || val[i] == '.')) {
          arr.push(val[i]!);
        }
      }
      return arr;
    }
    return [];
  }
}
